const colors = {
  // theme color
  // theme: "#f14140",
  theme: "#1976D2",

  // success: #00ffa9,
  // danger: #ff3400,
  // warning: #e5d700,

  productSectionBg: "#BBDEFB",
  organization: "#311B92",

  text: {
    dark: "#222222",
    normal: "#444444",
    muted: "#9a9a9a",
    gray: "#7a7a7a",
  },

  bg: {
    // screen: "#f6f6f4",
    screen: "#f9fafb",
    // vLight: "#fdfdfd",
    light: "#ededed",
    vLight: "#fdfeff",
  },

  cta: {
    seller: "#6a1b9a",
    product: "#00695c",
    customer: "#1976f2",
    reminder: "#d32f2f",
    factor: "#388e3c",
    note: "#f59e0b",
  },
  // typography colors
  textColorDark: "#343434",
  textColorDefault: "#656565",
  textColorGray: "#a9a9a9",
  placeholder: "#bcbcbc",
  iconColor: "#a9a9a9",
  progressBarInactive: "#f5f5f5",

  // background colors
  screensBg: "#f6f6f4",
  itemsBg: "#ffffff",

  innerItemsBg: "#fdfdfd",
  darkGlass: "#00000055",
  lightGlass: "#ffffff12",
  lightButtons: "#f7f7f7",
  lightBorder: "#f2f2f1",

  // status colors
  success: "#28a745",
  darkSuccess: "#188735",
  // info: '#17a2b8',
  info: "#0792a8",

  danger: "#dc3545",
  warning: "#ffc107",
  darkWarning: "#FF6000",
  darkestWarning: "#ff4000",
  transparent: "transparent",

  brightGreek: "#3742fa",
  purple: "#6200EA",

  // others
  border: "#f7f7f5",

  // labeled colors
  white: "#ffffff",
  cyan: "#00c1f1",
  blue: "#2673e9",
  black: "#000000",

  // specific screens
  splashScreenBg: "#f6f6f4",

  // report item
  sellerReports: ["#f9a4a0", "#f77c75"],
  saleReports: ["#bb95fc", "#9962f8"],
  productReports: ["#81d0fa", "#50bdf7"],
  customerReports: ["#f6d653", "#f1c720"],

  dark: {
    _00: "#000000",
    _02: "#222222",
    _04: "#444444",
    _06: "#666666",
    _08: "#888888",
    _10: "#aaaaaa",
    _12: "#cccccc",
    _13: "#dddddd",
    _14: "#eeeeee",
    _15: "#ffffff",
  },

  light: {
    _00: "#f0f0f0",
    _01: "#f1f1f1",
    _02: "#f2f2f2",
    _03: "#f3f3f3",
    _04: "#f4f4f4",
    _05: "#f5f5f5",
    _06: "#f6f6f6",
    _07: "#f7f7f7",
    _08: "#f8f8f8",
    _09: "#f9f9f9",
    _10: "#fafafa",
    _11: "#fbfbfb",
    _12: "#fcfcfc",
    _13: "#fdfdfd",
    _14: "#fefefe",
    _15: "#ffffff",
  },
};
export default colors;
